import { parseNumeric } from './parseNumeric';

/**
 * Converts a percent-scale value (5 meaning 5%) to its fraction (0.05).
 * Latitude's Ticker multiplies `type="percentage"` values by 100, so
 * percent-scale API fields (e.g. AssetTypeInfo.dayChange) must be scaled
 * down through this helper before being passed to it.
 *
 * Returns NaN for null, undefined, blank and non-numeric input, so a missing
 * value never reads as 0%.
 */
export function percentToFraction(
  percent: number | string | null | undefined,
): number {
  return parseNumeric(percent) / 100;
}
